/**
 * 页面组件的引入
 */
import { coverQuery } from "$common/utils/url/url";

export default {
  use: (Vue, Router, loadLanguageAsync) => {
    Vue.use(Router);
    let prefixName = window.location.pathname;
    //  设置 spa 的路由前缀
    const router = new Router({
      mode: "history",
      prefix: prefixName,
      routes: [{
        path: `*`,
        redirect: prefixName
      }, {
        name: "legal-policies",
        path: prefixName,
        component: resolve => import("./legal-policies").then(resolve)
      }]
    });
    //  路由切换懒加载对应的国家化文案
    router.beforeEach((to, from, next) => {
      coverQuery(to);
      if (
        window.$vm?.$root?.backRouterName &&
        to.name !== window.$vm?.$root?.backRouterName
      ) {
        this.$router.go(-1);
      } else {
        if (window.$vm?.$root) {
          window.$vm.$root.backRouterName = "";
        }
        loadLanguageAsync({
          router: to.name
        })
          .then(() => next())
          .catch(() => next());
      }
    });
    return router;
  }
};
